module.exports = __webpack_public_path__ + "fonts/antares_b209e128dc3c69bc8c5a901d01aa46c0.ttf";